import { supabase } from '../supabaseClient';

/* Accès aux données « affaires ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchDeals() {
  return supabase.from('affaires').select('*').order('ordre', { ascending: true });
}

export function insertDealFromTender(dealId, clientId, f, maxOrdre, n) {
  return supabase.from('affaires').insert({
    id: dealId,
    nom: f.nom.trim(),
    client_id: clientId,
    statut: 'a_travailler',
    type_projet: f.type_projet || null,
    notes: f.notes || null,
    boamp_idweb: n.idweb,
    ordre: maxOrdre + 1,
    created_at: new Date().toISOString(),
  });
}

export function updateDeal(id, patch) {
  return supabase
    .from('affaires')
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('id', id);
}

export function insertDeal(id, maxOrdre, row) {
  return supabase
    .from('affaires')
    .insert({ id, ...row, ordre: maxOrdre + 1, created_at: new Date().toISOString() });
}

export function deleteDeal(m) {
  return supabase.from('affaires').delete().eq('id', m.id);
}
